import { useState } from 'react';
import './style.scss';
import { useNavigate } from 'react-router-dom';

const ModalOrderWindow = ({ modalOpen, closeModal, productName }) => {
    const navigate = useNavigate();
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")

    const sendMessageToBot = async (botToken, chatId, text) => {
        try {
            const apiUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;
            const params = {
                chat_id: chatId,
                text: text
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            });

            const responseData = await response.json();

            if (response.status === 200) {
                console.log('Message sent successfully.');
                closeModal();
                navigate("/thanks");
            } else {
                alert("Щось пішло не так. Можете спробувать пізніше або позвоніть за номером в шапці сайту")
                console.error(`Failed to send message. Error code: ${responseData.status}`);
            }
        } catch (error) {
            console.error('An error occurred:', error.message);
        }
    }

    const onSendOrder = async () => {
        var message = `💲ЗАМОВЛЕННЯ В 1 КЛІК:

    Ім'я: ${name}
    Телефон: ${phone}
    Замовлення: ${productName};`;

        var token = "6508396749:AAGSkIjTxL-ZaoCQ04JCPbYd9h6fSZMzwKE";
        var chat_id = "-4016903344";

        await sendMessageToBot(token, chat_id, message)

    }

    return (
        <>
            <div className={`modal-container ${modalOpen ? 'active' : ''}`} >
                {/* Modal content */}
                <div className="modal-content">
                    <h2>Замовити в 1 клік!</h2>
                    <p class='modal-paragraph'>Після відправки заявки з вами зв'яжуться найближчим часом або в робочі години</p>
                    <input type="text" id="name" name="name" value={name} onChange={e => setName(e.target.value)} required placeholder="Ім'я"></input>
                    <input type="tel" id="phone" name="phone" value={phone} onChange={e => setPhone(e.target.value)} required placeholder="Номер телефона"></input>
                    <button className='send-button' onClick={onSendOrder}>Оформити замовлення</button>
                    <button className='close-button' onClick={closeModal}>X</button>
                </div>
            </div>
        </>

    )
}

export default ModalOrderWindow;